<div
  *ngIf="{filteredTasks: inspectionService.filteredTasks$ | async, brakeMeasurementTasks: inspectionService.brakeMeasurementTasks$ | async} as data">
  <div style="width:21cm;flex-direction: column;" id="storage" class="report-container printMe" layout-fill>
    <div style="background-color:white;flex-direction: column;">
      <div fxLayout="column" style="padding-left:8px">
        <div class="mx-2 mt-2" fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="column">
            <span class="mat-headline text-xl" fxFlex
              style="margin-bottom:8px;">{{inspectionService.report?.header?.title}}</span>
            <div class="mat-body-1">
              Work Order: #{{workOrderId}}</div>
            <div class="mat-body-1">
              Advisor: {{inspectionService.report?.header?.AdvisorName}}</div>
            <div class="mat-body-1">
              Customer: {{inspectionService.report?.header?.CustomerName}}</div>
            <div class="mat-body-1">
              Vehicle: {{inspectionService.report?.header?.VehicleYear}}
              {{inspectionService.report?.header?.VehicleMake}}
              {{inspectionService.report?.header?.VehicleModel}}

            </div>
            <div class="mat-body-1">
              VIN: {{inspectionService.report?.header?.Vin}}
            </div>
          </div>
          <div fxFlex class="dealership-logo-cell">
            <img style="height:126px;width:auto;"
              [src]="inspectionService?.dealershipLogo" alt="Logo"
              crossOrigin>
          </div>
        </div>
      </div>

      <div id="topContainer" fxLayout="row">
        <ng-container *ngFor="let tasks of data.filteredTasks | groupBy: 'Color' | pairs">
          <!-- {{tasks | json}} -->
          <div fxFlex="50" style="border:2px solid black;margin:8px;" *ngIf="tasks[0] == 'Green'" fxLayout="row wrap"
            fxLayoutAlign="start start">
            <div class="report-section-header" fxLayout="row" fxLayoutAlign="center center">
              <h3 class="mat-title m-0">{{getStatus(tasks[1][0]?.Color)}}</h3>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="50" *ngFor="let task of tasks[1]"
              style="padding:3px;">
              <div fxLayout="row" fxLayoutAlign="start center"
                *ngIf="!isExcludedTask(data.brakeMeasurementTasks, task)">
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="task.Color == 'Green'"
                  [ngStyle]="{color: '#00C853', margin: '0 2px 0 0'}">check_circle</mat-icon>
                <span class="mr-1" style="font-size: 11.5px;">{{task.TaskName}} {{getFluidFilled(task.FluidFilled)}}
                </span>
              </div>
            </div>
          </div>
        </ng-container>

        <div fxLayout="column" fxFlex="50">
          <div *ngIf="inspectionService.report?.tires?.length > 0"
            style="border:2px solid black;margin:8px; height: fit-content;">
            <div class="report-section-header" fxLayout="row" fxLayoutAlign="center center">
              <h3 class="mat-title m-0">Tires</h3>
            </div>

            <div fxLayout="row wrap" fxLayoutAlign="space-around center" style="padding:3px;">
              <div class="flex flex-row w-full h-8 items-center"
                style="justify-content: space-around; width: 100%;border-bottom: 1px solid lightgray">
                <div class="flex flex-row justify-center items-center">Tread depth</div>
                <div class="flex flex-row justify-center items-center">
                  <mat-icon class='mr-1 flex justify-center items-center text-xl' mat-font-set="material-icons"
                    style="color:#00C853; margin:0 2px 0 0">
                    check_circle</mat-icon>
                  <span>{{inspectionService.treadDepthSettings.greenTreadDepth}}/32 or greater</span>
                </div>
                <div class="flex flex-row justify-center items-center">
                  <mat-icon class='mr-1 flex justify-center items-center text-xl' mat-font-set="material-icons"
                    style="color:#FFD600; margin: 0 2px 0 0">
                    warning</mat-icon>
                  <span>{{inspectionService.treadDepthSettings.yellowTreadDepth}}/32 to
                    {{inspectionService.treadDepthSettings.greenTreadDepth-1}}/32</span>
                </div>
                <div class="flex flex-row justify-center items-center">
                  <mat-icon class='mr-1 flex justify-center items-center text-xl' mat-font-set="material-icons"
                    style="color:#D50000; margin: 0 2px 0 0">
                    report</mat-icon>
                  <span>{{inspectionService.treadDepthSettings.yellowTreadDepth-1}}/32 or less</span>
                </div>
              </div>
              <div class="w-full" fxLayout="column" fxLayoutAlign="center start">
                <h4 class="mat-subhead"
                  style="margin-bottom:4px;margin-top:8px;text-decoration:underline;margin-left: 24px">Wear Pattern</h4>
                <div fxLayout="column" fxLayoutAlign="center start" style="width:100%;">
                  <div fxLayout="row" style="margin-bottom:4px;height:21px;">
                    <b style="margin-right:2px;margin-left: 24px" class="mat-caption">LF:</b>
                    <span class="mat-caption"> {{inspectionService.report?.tires[0].wearPattern}}</span>
                  </div>
                  <div fxLayout="row" style="margin-bottom:4px;height:21px;">
                    <b style="margin-right:2px;margin-left: 24px" class="mat-caption">RF:</b>
                    <span class="mat-caption"> {{inspectionService.report?.tires[2].wearPattern}}</span>
                  </div>
                  <ng-container *ngIf="!hasDualRearTireSection(inspectionService.report?.tires)">
                    <div fxLayout="row" style="margin-bottom:4px;height:21px;">
                      <b style="margin-right:2px;margin-left: 24px" class="mat-caption">LR:</b>
                      <span class="mat-caption"> {{inspectionService.report?.tires[1].wearPattern}}</span>
                    </div>
                    <div fxLayout="row" style="margin-bottom:4px;height:21px;">
                      <b style="margin-right:2px;margin-left: 24px" class="mat-caption">RR:</b>
                      <span class="mat-caption"> {{inspectionService.report?.tires[3].wearPattern}}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
              <!--
              <div fxLayout="column wrap" style="margin-top:24px" fxFlex="50" fxLayoutAlign="center start">
                <div *ngFor="let task of inspectionService.report?.tireOther">
                  <div fxLayout="row" fxFlex style="margin-bottom:2px;padding:2px" fxLayoutAlign="start center"
                    *ngIf="task.Color === 'Red'">
                    <mat-icon mat-font-set="material-icons" *ngIf="task.Color === 'Red'"
                      [ngStyle]=" {color: 'red', margin: '0 2px 0 0'} ">cancel</mat-icon>
                    <span class="mat-caption" *ngIf="task.Color === 'Red'">{{task.TaskName}}</span>
                  </div>
                </div>
              </div> -->

              <div class="flex flex-row justify-between text-xs w-full">
                <div class="ml-4 mt-1"
                  *ngIf="inspectionService.inspection?.tireOther && inspectionService.inspection?.tireOther[0]?.tasks?.length > 0">
                  <div class="flex flex-col" *ngFor="let task of inspectionService.inspection?.tireOther[0]?.tasks">
                    <div class="flex items-center mr-6" *ngIf="task.redBox">
                      <mat-icon mat-font-set="material-icons" style="color:#D50000; margin:0 2px 0 0">report</mat-icon>
                      <span class="whitespace-nowrap" style="padding:2px">{{task.taskName}}</span>
                    </div>
                  </div>
                </div>

                <div class="w-full mt-1"
                  *ngIf="inspectionService.inspection?.tireOtherGm && inspectionService.inspection?.tireOtherGm[0]?.tasks?.length > 0">
                  <div class="flex flex-col" *ngFor="let task of inspectionService.inspection?.tireOtherGm[0]?.tasks">
                    <div class="flex items-center" *ngIf="task.greenBox">
                      <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                        style="color:#00C853; margin:0 2px 0 0">check_circle</mat-icon>
                      <span style="padding:2px">{{task.taskName}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div fxFlex="50" fxLayout="column" fxLayoutAlign="center start">
                <h4 class="mat-subhead"
                  style="margin-bottom:4px;margin-top:8px;text-decoration:underline;margin-left: 24px">Pressure</h4>
                <div fxLayout="row" fxLayoutAlign="start center"
                  style="padding-bottom:4px;height:24px;margin-left:24px">
                  <b style="margin-right:2px" class="mat-caption">LF:</b>
                  <span class="mat-caption">In: {{inspectionService.report?.tires[0].psiIn}} // Out:
                    {{inspectionService.report?.tires[0].psiOut}}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center"
                  style="padding-bottom:4px;height:24px;margin-left:24px">
                  <b style="margin-right:2px" class="mat-caption">RF:</b>
                  <span class="mat-caption"> In: {{inspectionService.report?.tires[2].psiIn}} // Out:
                    {{inspectionService.report?.tires[2].psiOut}}</span>
                </div>
                <ng-container *ngIf="!hasDualRearTireSection(inspectionService.report?.tires)">
                  <div fxLayout="row" fxLayoutAlign="start center"
                    style="padding-bottom:4px;height:24px;margin-left:24px">
                    <b style="margin-right:2px" class="mat-caption">LR:</b>
                    <span class="mat-caption">In: {{inspectionService.report?.tires[1].psiIn}} // Out:
                      {{inspectionService.report?.tires[1].psiOut}}</span>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center"
                    style="padding-bottom:4px;height:24px;margin-left:24px">
                    <b style="margin-right:2px" class="mat-caption">RR:</b>
                    <span class="mat-caption">In: {{inspectionService.report?.tires[3].psiIn}} // Out:
                      {{inspectionService.report?.tires[3].psiOut}}</span>
                  </div>
                </ng-container>
              </div>

              <div fxFlex="50" fxLayout="column" fxLayoutAlign="center start">
                <h4 class="mat-subhead"
                  style="margin-bottom:4px;margin-left:24px;margin-top:8px;text-decoration:underline;">Tread</h4>
                <div fxLayout="row" style="padding-bottom:4px;padding-left:4px" fxLayoutAlign="start center">
                  <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                    *ngIf="inspectionService.report?.tires[0].green"
                    [ngStyle]="{color: '#00C853', margin: '0 2px 0 0'}">check_circle</mat-icon>
                  <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                    *ngIf="inspectionService.report?.tires[0].yellow"
                    [ngStyle]="{color: '#FFD600', margin: '0 2px 0 0'}">warning</mat-icon>
                  <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                    *ngIf="inspectionService.report?.tires[0].red"
                    [ngStyle]="{color: '#D50000', margin: '0 2px 0 0'}">cancel</mat-icon>
                  <b style="margin-right:2px" class="mat-caption">LF:</b>
                  <span class="mat-caption"> {{inspectionService.report?.tires[0].treadDepth}}/32</span>
                </div>
                <div fxLayout="row" style="padding-bottom:4px;padding-left:4px" fxLayoutAlign="start center">
                  <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                    *ngIf="inspectionService.report?.tires[2].green"
                    [ngStyle]="{color: '#00C853', margin: '0 2px 0 0'}">check_circle</mat-icon>
                  <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                    *ngIf="inspectionService.report?.tires[2].yellow"
                    [ngStyle]="{color: '#FFD600', margin: '0 2px 0 0'}">warning</mat-icon>
                  <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                    *ngIf="inspectionService.report?.tires[2].red"
                    [ngStyle]="{color: '#D50000', margin: '0 2px 0 0'}">cancel</mat-icon>
                  <b style="margin-right:2px" class="mat-caption">RF:</b>
                  <span class="mat-caption"> {{inspectionService.report?.tires[2].treadDepth}}/32</span>
                </div>
                <ng-container *ngIf="!hasDualRearTireSection(inspectionService.report?.tires)">
                  <div fxLayout="row" style="padding-bottom:4px;padding-left:4px" fxLayoutAlign="start center">
                    <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                      *ngIf="inspectionService.report?.tires[1].green"
                      [ngStyle]="{color: '#00C853', margin: '0 2px 0 0'}">check_circle</mat-icon>
                    <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                      *ngIf="inspectionService.report?.tires[1].yellow"
                      [ngStyle]="{color: '#FFD600', margin: '0 2px 0 0'}">warning</mat-icon>
                    <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                      *ngIf="inspectionService.report?.tires[1].red"
                      [ngStyle]="{color: '#D50000', margin: '0 2px 0 0'}">cancel</mat-icon>
                    <b style="margin-right:2px" class="mat-caption">LR:</b>
                    <span class="mat-caption"> {{inspectionService.report?.tires[1].treadDepth}}/32</span>
                  </div>
                  <div fxLayout="row" style="padding-bottom:4px;padding-left:4px" fxLayoutAlign="start center">
                    <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                      *ngIf="inspectionService.report?.tires[3].green"
                      [ngStyle]="{color: '#00C853', margin: '0 2px 0 0'}">check_circle</mat-icon>
                    <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                      *ngIf="inspectionService.report?.tires[3].yellow"
                      [ngStyle]="{color: '#FFD600', margin: '0 2px 0 0'}">warning</mat-icon>
                    <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                      *ngIf="inspectionService.report?.tires[3].red"
                      [ngStyle]="{color: '#D50000', margin: '0 2px 0 0'}">cancel</mat-icon>
                    <b style="margin-right:2px" class="mat-caption">RR:</b>
                    <span class="mat-caption"> {{inspectionService.report?.tires[3].treadDepth}}/32</span>
                  </div>
                </ng-container>
              </div>
            </div>

            <div *ngIf="inspectionService.report?.taskOther.length > 0">
              <div class="report-section-header" fxLayout="row" fxLayoutAlign="center center">
                <h3 class="mat-title m-0">Battery Voltage & Oil Life</h3>
              </div>
              <div class="grid grid-cols-2 justify-start">
                <div *ngFor="let task of inspectionService.report?.taskOther">
                  <div *ngIf="task.DisplayBatteryVoltage" style="padding:3px;" fxLayoutAlign="start center">
                    <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                      [ngStyle]=" {margin: '0 2px 0 0'} ">battery_full</mat-icon>
                    <span class="mat-caption">{{task.TaskName}}: {{task.BatteryVoltage}}v</span>
                  </div>
                  <div *ngIf="task.DisplayOilLife" style="padding:3px;" fxLayoutAlign="start center">
                    <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                      [ngStyle]=" { margin: '0 2px 0 0'} ">opacity</mat-icon>
                    <span class="mat-caption">{{task.TaskName}}: {{task.OilLife}}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngFor="let dualSection of getOptionalTireSections(inspectionService.report?.tires)"
            style="border:2px solid black;margin:8px; height: fit-content;">
            <div class="report-section-header" fxLayout="row" fxLayoutAlign="center center">
              <h3 class="mat-title m-0">{{dualSection.categoryName}}</h3>
            </div>
            <div fxLayout="column" fxLayoutAlign="center start" style="padding:3px;">
              <div *ngFor="let tire of dualSection.tires" fxLayout="row" fxLayoutAlign="start center"
                style="padding-bottom:4px;padding-left:4px;">
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="tire.green" [ngStyle]="{color: '#00C853', margin: '0 2px 0 0'}">check_circle</mat-icon>
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="tire.yellow" [ngStyle]="{color: '#FFD600', margin: '0 2px 0 0'}">warning</mat-icon>
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="tire.red" [ngStyle]="{color: '#D50000', margin: '0 2px 0 0'}">cancel</mat-icon>
                <b style="margin-right:2px" class="mat-caption">{{tire.taskName}}:</b>
                <span class="mat-caption">{{tire.treadDepth}}/32 &mdash; In: {{tire.psiIn}} // Out:
                  {{tire.psiOut}}<ng-container *ngIf="tire.wearPattern"> &mdash;
                    {{tire.wearPattern}}</ng-container></span>
              </div>
            </div>
          </div>

          <div *ngIf="data.brakeMeasurementTasks?.length > 0"
            style="border:2px solid black;margin:8px; height: fit-content;">
            <div class="report-section-header" fxLayout="row" fxLayoutAlign="center center">
              <h3 class="mat-title m-0">Brakes</h3>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="space-around center" class="p-1.5">
              <div *ngFor="let task of data.brakeMeasurementTasks" fxLayout="row" fxLayoutAlign="start center"
                fxFlex="50">
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="task.Color == 'Green'"
                  [ngStyle]="{color: '#00C853', margin: '0 2px 0 0'}">check_circle</mat-icon>
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="task.Color=='Yellow'" [ngStyle]="{color: task.Color, margin:
                                    '0 2px 0 0'}">warning</mat-icon>
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="task.Color=='Red'" [ngStyle]="{color: task.Color, margin:
                                    '0 2px 0 0'}">cancel</mat-icon>
                <span class="mr-1" style="font-size: 11.5px;">{{task.TaskName}}
                  {{getBrakeMeasurement(task, inspectionService.brakeMeasurements, inspectionService.inspection)}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div fxLayout="row" style="width:100%">
        <ng-container *ngFor="let tasks of data.filteredTasks | groupBy: 'Color' | pairs">
          <div *ngIf="(tasks[0]=='Red' || tasks[0]=='Yellow')" fxFlex="50" style="border:2px solid black;margin:8px;"
            fxLayout="row wrap" fxLayoutAlign="start start">
            <div class="report-section-header" fxLayout="row" fxLayoutAlign="center center">
              <h3 class="mat-title m-0">{{getStatus(tasks[1][0].Color)}}</h3>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="50" *ngFor="let task of tasks[1]"
              style="padding:3px;">
              <div fxLayout="row" fxLayoutAlign="start center"
                *ngIf="!isExcludedTask(data.brakeMeasurementTasks, task)">
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="task.Color=='Yellow'" [ngStyle]="{color: task.Color, margin:
                              '0 2px 0 0'}">warning</mat-icon>
                <mat-icon class="flex justify-center items-center text-xl" mat-font-set="material-icons"
                  *ngIf="task.Color=='Red'" [ngStyle]="{color: task.Color, margin:
                              '0 2px 0 0'}">cancel</mat-icon>
                <span class="mr-1" style="font-size: 11.5px;">{{task.TaskName}} {{getFluidFilled(task.FluidFilled)}}
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div id="test" style="break-before:page;margin:8px;position:relative;display:block; "
        *ngIf="inspectionService.report?.quoteLines?.length >  0" fxLayout="column">
        <div id="quoteHeader" style="margin-bottom:16px;">
          <h3 class="mat-headline" style="margin-bottom:8px;">Quote Details</h3>
          <hr class="hr-report">
        </div>
        <div id="quoteContainer">
          <div style="page-break-inside:avoid;margin-bottom:12px;position:relative;display:block;"
            *ngFor="let line of inspectionService.report?.quoteLines | orderBy: ['Case'];">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div fxLayout="column" fxLayoutAlign="center start">
                <span class="mat-subhead" style="text-decoration: underline; word-break: break-word">Case {{line.Case}}
                  -
                  {{line.TaskName}}</span>
                <span class="mat-caption" style="margin:2px 0px 2px 8px;">{{line.RecommendedHours}} Labour Hours -
                  <i>Expires {{line.ExpirationDate | moment:'MM.DD.YYYY'}}</i>
                </span>
                <span class="mat-caption" style="margin:2px 0px 2px 8px;">Employee: {{line.Employee}}</span>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="space-between center" style="margin-left:8px;">
              <div fxFlex="65" fxLayoutAlign="start start" fxLayout="column">
                <div fxLayout="column">
                  <span class="mat-body-2">
                    Concern
                  </span>
                  <span class="mat-caption" style="margin:2px 0px 2px 8px; word-break: break-word">
                    {{line.Note || "Not Available" }}
                  </span>
                </div>
                <div fxLayout="column">
                  <span class="mat-body-2">
                    Cause
                  </span>
                  <span class="mat-caption" style="margin:2px 0px 2px 8px; word-break: break-word">
                    {{line.Cause || "Not Available"}}
                  </span>
                </div>
                <div fxLayout="column">
                  <span class="mat-body-2">
                    Correction
                  </span>
                  <span class="mat-caption"
                    style="margin:2px 0px 2px 8px; word-break: break-word;">{{line.Recommendation
                    || "Not Available "}}</span>
                </div>
              </div>
              <div fxFlex="30" fxLayout="row wrap" fxLayoutAlign="start start" style="margin-right:8px;">
                <div fxLayout="row" fxFlex="100">
                  <span class="mat-body-2">Subtotals</span>
                </div>
                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px; ">
                  <span class="mat-caption">Labour:</span>
                  <span class="mat-caption">{{line.labourSubTotal | currency:'$'}}</span>
                </div>
                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                  <span class="mat-caption">Parts:</span>
                  <span class="mat-caption">{{line.partsSubTotal | currency:'$'}}</span>
                </div>
                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                  <span class="mat-caption">Additional Charges:</span>
                  <span class="mat-caption">{{line.additionalCharges | currency:'$'}} </span>
                </div>
                <div fxLayout="row" fxFlex="100 " fxLayoutAlign="space-between center" style="margin:2px 0px 2px
                            8px;">
                  <span class="mat-caption">Tax:</span>
                  <span class="mat-caption">{{line.tax | currency: '$'}}</span>
                </div>
                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">
                  <span class="mat-body-2">Total:</span>
                  <span class="mat-body-2">{{line.CaseTotal| currency:'$'}}</span>
                </div>
              </div>
            </div>
            <mat-divider style="margin-top:8px;"></mat-divider>
          </div>
        </div>

        <div id="quoteTotal" fxLayout="column" fxLayoutAlign="center end" style="width:100%;">
          <span class="mat-subhead" style="font-weight:500;">Quote Total:
            {{getQuoteTotal(inspectionService.report?.quoteLines) | currency:'$'}} </span>
          <span class="mat-caption">*Shop supplies may apply.</span>
        </div>
      </div>

      <div *ngIf="this.inspectionService.bodyReportObject.signature"
        style="break-before:page;margin:8px;position:relative;display:block;">
        <inspection-body-report [printView]=true></inspection-body-report>
      </div>
    </div>
  </div>
</div>